<template>
  <div class="portfolio-widget">

    <div class="container-header">
      <div class="container-header__title">{{ i18n.dash_wallet() }}</div>
    </div>

    <md-card class="container container_50">
      <template v-if="currentAsset">
        <div class="balances">
          <div class="balance-item" v-for="bl in showedBalances" :key="`balance-${bl.key}`" @click="$emit(events.assetChange, bl.key)">
            <p class="text_medium">{{ bl.key }}</p>
            <p class="text_medium">{{ bl.balance }}</p>
          </div>
        </div>
        <div class="btn-flex">
          <div>
            <md-switch class="md-primary" v-model="hideZeros">{{ i18n.lbl_zeros() }}</md-switch>
          </div>
          <div>
            <md-button class="md-button btn md-primary md-theme-default md-yellow flex-btn" @click="refresh" :disabled="isLoading">
              <md-icon class="md-size-1x">autorenew</md-icon>
            </md-button>
          </div>
        </div>
        <div class="portfolio-widget__content">

          <div class="portfolio-widget__asset">
            <select-field v-if="currentAsset"
                          :value="currentAsset"
                          :values="Object.keys(accountBalances)"
                          :callLocation="callLocation"
                          @input="$emit(events.assetChange, $event)"
            />
          </div>

          <div class="portfolio-widget__amount" v-if="!isTron">
            <div class="portfolio-widget__amount-value text_xl_large">{{ balance }} {{ assetIcon }}</div>
            <div class="portfolio-widget__amount-converted text_medium">{{ convertedBalance }} $</div>
          </div>
          <div class="portfolio-widget__amount" v-else>
            <div class="portfolio-widget__amount-value text_xl_large">{{ balance }} {{ assetIcon }}</div>
            <div class="amount-wrap">
              <div class="portfolio-widget__amount-converted text_medium">{{ convertedBalance }} $</div>
              <div class="portfolio-widget__amount-converted text_medium">{{i18n.total_wallet()}} {{ tronSum }} USDT</div>
            </div>
          </div>
        </div>


        <div class="btn-wrap space-between">
          <md-button class="btn md-primary md-yellow"
                     @click="$router.push({name: 'topup-balance.make', params: {tokenCode: currentAsset}})"
                     :disabled="checkTransferable || accountState !== 'approved'"
          >{{ i18n.lbl_refill() }}</md-button>
          <md-button @click="onSend"
                     :disabled="checkTransferable || accountState !== 'approved'"
                     class="btn md-primary md-yellow"
          >{{ i18n.lbl_send() }}</md-button>
        </div>
        <div class="sub-title-wrap">
          <p class="text_large sub-title">{{ i18n.lbl_subs() }}</p>
          <span @click="$emit('setSubFull')" class="sub-title-btn"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>fullscreen</title><path d="M5,5H10V7H7V10H5V5M14,5H19V10H17V7H14V5M17,14H19V19H14V17H17V14M10,17V19H5V14H7V17H10Z" /></svg></span>
        </div>
        <div class="protfolio-subwallets protfolio-subwallet-wrap" v-if="formatSubwalletList.length">
          <div v-for="subwallet in formatSubwalletList" :key="`subwallet-${subwallet.Balance}`">
            <div class="text_medium protfolio-subwallet" @click="$emit('setActiveSubwallet', subwallet)">
              <span>{{ subwallet.Description }}</span>
              <div>
                <span class="subwallet-balance">{{ subwallet.Balance }}</span>
                <span>{{ subwallet.Asset }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <p class="text_medium">---</p>
        </div>
        <md-button class="md-button btn md-primary md-theme-default w-100 sub-button md-yellow" @click="$emit('toggleAdd')">{{ i18n.th_sub() }}</md-button>
      </template>

      <template v-else>
        <md-card-content>
          <div class="container__no-data">
            <md-icon class="md-size-4x">toll</md-icon>
            <div class="text_large">{{ i18n.th_no_assets_in_your_wallet() }}</div>
            <div class="text_description text_margin text_medium">{{ i18n.th_here_will_be_tokens() }}</div>
          </div>
        </md-card-content>
      </template>

    </md-card>
  </div>
</template>

<script>
  import config from '@conf'
  import SelectField from '@com/fields/SelectField'
  import CurrencyRound from '@com/mixins/currency.round.mixin'

  import { mapGetters, mapActions } from 'vuex'
  import { vuexTypes } from '@vuex/types'
  import { vueRoutes } from '@router/const'
  import { i18n } from '@js/i18n'
  import { commonEvents } from '@js/events/common_events'
  import { CurrencyHelper } from '@js/helpers/currency.helper'
  import { CRYPTO_CURRENCYS, CRYPTO_CURRENCYS_USDT } from '@utils/consts'
  import get from 'lodash/get'

  export default {
    name: 'portfolio-widget',
    mixins: [CurrencyRound],
    components: { SelectField },
    props: ['currentAsset', 'accountState', 'tronSum', 'subwallets'],
    emits: ['toggleAdd', 'setSubFull'],
    data: _ => ({
      vueRoutes,
      callLocation: 'dashboard_portfolio',
      i18n,
      events: {
        assetChange: commonEvents.assetChangeEvent
      },
      isLoading: false,
      hideZeros: false,
      CRYPTO_CURRENCYS,
      CRYPTO_CURRENCYS_USDT,
      timer: {
        minutes: 1,
        seconds: 0,
        timerDone: false,
        timerInterval: null
      }
    }),
    computed: {
      ...mapGetters([
        vuexTypes.accountBalances,
        vuexTypes.userTransferableTokens
      ]),
      formatSubwalletList () {
        if (this.subwallets && this.subwallets.length) {
          return this.subwallets.filter(wallet => wallet.Asset === this.currentAsset)
        }
        return []
      },
      isTron () {
        let arr = Object.values(CRYPTO_CURRENCYS)
        arr = arr.filter(el => el.includes('USDT'))
        return arr.includes(this.currentAsset)
      },
      assetIcon () {
        return CurrencyHelper.getCurrencyIcon(this.currentAsset)
      },
      showedBalances () {
        const obj = {}
        Object.values(CRYPTO_CURRENCYS_USDT).forEach(el => {
          if (this.hideZeros) {
            // eslint-disable-next-line
            if (this.accountBalances[el].balance != 0) {
              obj[el] = {key: el, balance: this.roundCurrency2(this.accountBalances[el].balance)}
            }
          } else {
            obj[el] = {key: el, balance: this.roundCurrency2(this.accountBalances[el].balance)}
          }
        })
        return obj
      },
      balance () {
        if (!Object.values(CRYPTO_CURRENCYS).includes(this.currentAsset)) {
          return this.roundCurrency(get(this.accountBalances, `${this.currentAsset}.balance`) || 0, this.currentAsset)
        }
        return this.roundCurrency2(this.accountBalances[this.currentAsset].balance)
      },
      convertedBalance () {
        return Number(this.roundCurrency(get(this.accountBalances, `${this.currentAsset}.converted_balance`) || 0, this.currentAsset)).toFixed(2)
      },
      imgUrl () {
        const logoKey = get(this.accountBalances, `${this.currentAsset}.asset_details.details.logo.key`)
        if (logoKey) {
          return `${config.FILE_STORAGE}/${logoKey}`
        }
        const defaultUrl = '../../../../../static/coin-picture.png'
        return defaultUrl
      },
      checkTransferable () {
        return !(this.userTransferableTokens.map(token => token.code)).includes(this.currentAsset)
      }
    },
    mounted () {
      this.startTimer()
    },
    methods: {
      ...mapActions({
        loadBalances: vuexTypes.GET_ACCOUNT_BALANCES
      }),
      async created () {
        await this.loadBalances()
      },
      restartTimer () {
        this.timer.minutes = 1
        this.timer.seconds = 0
        this.startTimer()
      },
      async refresh () {
        this.isLoading = true
        await this.loadBalances()
        this.isLoading = false
      },
      startTimer () {
        if (this.timer.timerInterval) {
          clearInterval(this.timer.timerInterval)
        }
        this.timer.timerInterval = setInterval(async () => {
          if (this.timer.seconds > 0) {
            this.timer.seconds--
          } else if (this.timer.minutes > 0) {
            this.timer.minutes--
            this.timer.seconds = 59
          } else {
            clearInterval(this.timer.timerInterval)
            await this.loadBalances()
            console.log('restart')
            this.restartTimer()
          }
        }, 1000)
      },
      onSend () {
        this.$router.push({
          name: 'transfers.make:tokenCode',
          params: {tokenCode: this.currentAsset}})
      }
    },
    beforeDestroy () {
      if (this.timer.timerInterval) {
        clearInterval(this.timer.timerInterval)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~scss/variables.scss';
  @import '~scss/mixins.scss';
  .btn-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .flex-btn {
      min-width: 50px;
      height: 40px;
      .md-icon {
      color: $default-light-white;
      }
      .md-icon-font {
        color: $default-black !important;
      }
    }
  }
  .balances {
    max-height: 250px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 8px;
    }
    &::-webkit-scrollbar-track {
      background:  #e1e1e1;
      border-radius: 8px;
    }
    &::-webkit-scrollbar-thumb {
      background: #757575;
      border-radius: 8px;
    }
    .balance-item {
      display: flex;
      justify-content: space-between;
      padding: 5px 0;
      transition: all 0.2s ease-in-out;
      cursor: pointer;
      &:hover {
        background-color: $light-grey;
      }
    }
  }
  .sub-title-btn {
    display: block;
    width: 20px;
    height: 20px;
    cursor: pointer;
    transition: all 0.4s ease-in-out;
    &:hover {
      opacity: 0.7;
    }
  }
  .protfolio-subwallet-wrap {
    max-height: 150px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 8px;
    }
    &::-webkit-scrollbar-track {
      background:  #e1e1e1;
      border-radius: 8px;
    }
    &::-webkit-scrollbar-thumb {
      background: #757575;
      border-radius: 8px;
    }
  }
  .sub-title-wrap {
    margin-top: 15px;
    padding-top: 10px;
    border-top: 1px solid black;
    display: flex;
    justify-content: space-between;
  }
  .sub-button {
    width: 100%;
  }
  .protfolio-subwallets {
    margin-top: 15px;
    .protfolio-subwallet {
      display: flex;
      justify-content: space-between;
      padding: 15px 5px;
      flex-wrap: nowrap;
      transition: all 0.2s ease-in-out;
      cursor: pointer;
      &:hover {
        background-color: $defalut-gray;
      }
      div {
        display: flex;
        gap: 5px;
      }
      white-space: nowrap;
      .subwallet-balance {
        display: block;
        max-width: 40px;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    .not-allowed {
      opacity: 0.7;
      cursor: not-allowed;
      &:hover {
        background-color: inherit;
      }
    }
  }
  .amount-wrap {
    .portfolio-widget__amount-converted {
      &:last-child {
        margin-top: 10px;
      }
    }
  }

  .portfolio-widget {
    flex: 1 1 440px;
    max-width: 440px;

    @include respond-to(large) {
      flex: 1 1 400px;
      max-width: 400px;
    }

    @include respond-to(medium) {
      width: 100%;
      max-width: inherit;
      margin-bottom: 12px;
    }

    @include respond-to(xsmall) {
      max-width: 100%;
    }

    &__content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
    }

    &__asset {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;

      @include respond-to(small) {
        width: 140px;
      }

      & /deep/ .md-field {
        & input {
          text-align: center;
          // @include font('secondary', 32px);
          @include respond-to(small) {
            // @include font('secondary', 26px);
          }
        }
      }
    }

    &__amount {
      margin: 34px 0;

      @include respond-to(small) {
        margin: 22px 0;
      }
    }

    &__amount-value {
      margin-bottom: 10px;
      //@include font('secondary', 32px);
    }

    &__amount-converted {
  /*    color: $col-text-secondary;*/
    }
  }

  .portfolio-widget__asset-picture {
    margin-bottom: 32px;

    @include respond-to(medium) {
      margin-right: 16px;
      margin-bottom: 0;
    }

    img {
      width: 142px;
      height: 142px;

      @include respond-to(medium) {
        width: 80px;
        height: 80px;
        padding: 0;
      }
    }

    .portfolio-widget__asset {
      @include respond-to(medium) {
        padding: 0 !important;
      }
    }
  }

  .portfolio-widget__asset-value {
    margin-bottom: 16px;
    font-size: 24px;
    letter-spacing: .2px;

    @include respond-to(medium) {
      font-size: 20px;
      margin-bottom: 4px;
    }

    @include respond-to(xsmall) {
      font-size: 16px;
    }
  }

  .portfolio-widget__asset-usd {
    font-size: 16px;
    letter-spacing: .2px;
    color: rgba(0, 0, 0, .55);

    @include respond-to(xsmall) {
      font-size: 14px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/vue/app/dashboard/index/Dashboard.PortfolioWidget.vue